import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'src/services/MetaService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.css']
})
export class TermsOfServiceComponent implements OnInit, OnDestroy {

  constructor(private _router: Router, private canonicalService: MetaService,private titleService: Title) { 
    this.titleService.setTitle("LawShelf Educational Media");
  }

  ngOnInit() {
    this.canonicalService.createCanonicalURL(this._router.url, "/termsofserviceview/");
  }

  ngOnDestroy(): void {
    this.canonicalService.removeCanonicalURL();
  }
}
